<app-skeleton [loading]="loading" height="204px">
    <app-source-detail [baseInfo]="baseInfo"
        [capacityPercentData]="usageValue |fn:detail"
        [detail]="detail"
        [event]="item"
        [loading]="updateLoading"
        icon="#infigo-host"
        type="host">
    </app-source-detail>
</app-skeleton>
